import api from './api';
import loadApplicationData from './loadApplicationData';
import getQuickQuote from './getQuickQuote';
import setSampleProducts from './setSampleProducts';
import setApplicantDetails from './setApplicantDetails';
import isValidMail from './isValidMail';
import isValidPassword from './isValidPassword';
import mapMoney from './mapMoney';
import register from './register';
import softCheck from './softCheck';

const service = {
    api,
    loadApplicationData,
    getQuickQuote,
    setSampleProducts,
    setApplicantDetails,
    isValidMail,
    isValidPassword,
    mapMoney,
    register,
    softCheck,
};

export default service;



// WEBPACK FOOTER //
// ./src/service/index.js